import { render } from "./role-editor.vue?vue&type=template&id=1b106adc&scoped=true"
import script from "./role-editor.vue?vue&type=script&lang=ts"
export * from "./role-editor.vue?vue&type=script&lang=ts"

import "./role-editor.vue?vue&type=style&index=0&id=1b106adc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b106adc"

export default script